export enum ESelectionRangeMode {
  OWN = 'OWN',
  PREDEFINED = 'PREDEFINED',
}
